import React from 'react';
import classes from './Lineups2.module.css';
import TeamLineups2 from './TeamLineups2';
import { useTranslation } from 'react-i18next';

const Lineups2 = ({ homeTeam, awayTeam }) => {
    const {t}=useTranslation();
    return (
        <div className={classes.container}>

            {/* Home info bar */}
            <div className={classes.infoBar}>
                <div className={classes.infoTeam}>
                    <img src={homeTeam?.team?.logo} alt={homeTeam?.team?.name} className={classes.infoLogo} />
                    <span className={classes.infoName}>{homeTeam?.team?.name}</span>
                </div>
                <span className={classes.infoLabel}>{t("127")}</span>
                <span className={classes.infoFormation}>{homeTeam?.formation}</span>
            </div>

            {/* Pitch */}
            <div className={classes.pitchWrap}>
                <img src="/assets/images/football-ground.jpg" alt="pitch" className={classes.pitchImg} />

                {/* Pitch overlay tint */}
                <div className={classes.pitchTint} />

                {/* Centre line */}
                <div className={classes.centreLine} />

                <div className={classes.homeHalf}>
                    <TeamLineups2
                        homeTeam={true}
                        team={homeTeam?.team}
                        coach={homeTeam?.coach}
                        startXI={homeTeam?.startXI}
                        formation={homeTeam?.formation}
                    />
                </div>

                <div className={classes.awayHalf}>
                    <TeamLineups2
                        homeTeam={false}
                        team={awayTeam?.team}
                        coach={awayTeam?.coach}
                        startXI={awayTeam?.startXI}
                        formation={awayTeam?.formation}
                    />
                </div>
            </div>

            {/* Away info bar */}
            <div className={`${classes.infoBar} ${classes.infoBarAway}`}>
                <span className={classes.infoFormation}>{awayTeam?.formation}</span>
                <span className={classes.infoLabel}>{t("127")}</span>
                <div className={`${classes.infoTeam} ${classes.infoTeamReverse}`}>
                    <img src={awayTeam?.team?.logo} alt={awayTeam?.team?.name} className={classes.infoLogo} />
                    <span className={classes.infoName}>{awayTeam?.team?.name}</span>
                </div>
            </div>

        </div>
    );
};

export default Lineups2;